import {DefaultSettings, settings} from '../../../settings/settings-util';
import reducer from './reducers/index';
import {h, VNode} from "virtual-dom";
import ClearSkipToContentAction from "./actions/clearSkipToContentAction";
import SkipToContentAction from "./actions/skipToContentAction";
import {Reducer, Store} from "redux";
import {AlmeState} from "../../../wireup/AlmeState";


export default class SkipToContent
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;


    //#region Public Interface

    constructor(passedSettings: DefaultSettings = settings)
    {
        this._settings = passedSettings;
    }

    static getDefaultSettings(): DefaultSettings
    {
        return settings;
    }

    initialize(store): void
    {
        this._store = store;
    }

    getReducer(): Reducer<AlmeState["Window"]>
    {
         return reducer;
    }

    getRenderer()
    {
        return (): VNode =>
        {
            const { skipToContentLink, skipToContentWrapper } = this._settings.classNames;
            const { skipToContentLinkText } = this._settings.textConstants;

            const linkId = this._settings.elementIds.skipToContentLink;
            const wrapperId = this._settings.elementIds.skipToContentWrapper;

            const properties =
            {
                className: skipToContentLink,
                href: "javascript:void(0);",
                id: linkId,
                onclick: (e: Event): void =>
                {
                    this._store?.dispatch(SkipToContentAction.createAction(this._settings));
                    this._store?.dispatch(ClearSkipToContentAction.createAction(this._settings));
                },
                tabIndex: this.shouldDisable() ? -1 : 0,
            };

            const link = h("a", properties, skipToContentLinkText);

            return h("div", { className: skipToContentWrapper, id: wrapperId }, [link]);
        };
    }

    //#endregion



    //#region Helper Methods

    shouldDisable(): boolean
    {
        const { Base, SkipToContent } = this._settings.stateLocations.Window;

        return this._store?.getState()[Base][SkipToContent.Base][SkipToContent.shouldDisable];
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-skip-to-content/src/window-skip-to-content.ts